export default {
  facebook: "https://business.facebook.com/gamelaka",
  instagram: "https://www.instagram.com/gamelaka",
  x: "https://x.com/gamelaka",
};
